import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Layout from '../components/Layout';
import './MyFavorites.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MyFavorites = () => {
  const navigate = useNavigate();
  const { sessionToken } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/marketplace/favorites`, {
        headers: { Authorization: `Bearer ${sessionToken}` }
      });

      if (response.data.success) {
        setFavorites(response.data.brands || []);
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
      setError('Failed to load favorites');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFavorite = async (brandId) => {
    try {
      await axios.delete(`${API}/brands/${brandId}/favorite`, {
        headers: { Authorization: `Bearer ${sessionToken}` }
      });
      
      setFavorites(favorites.filter(b => b.id !== brandId));
    } catch (error) {
      console.error('Error removing favorite:', error);
      setError('Failed to remove favorite');
    }
  };

  if (loading) return <Layout><div className="loading-state">Loading favorites...</div></Layout>;

  return (
    <Layout>
      <div className="my-favorites-page">
        <div className="favorites-header">
          <h1>❤️ My Favorite Brands</h1>
          <p>Brands you follow will send you personalized collections</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {favorites.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🏪</div>
            <h2>No Favorites Yet</h2>
            <p>Explore the marketplace and favorite brands to receive personalized try-on collections</p>
            <button className="btn-primary" onClick={() => navigate('/marketplace')}>
              Browse Marketplace
            </button>
          </div>
        ) : (
          <div className="favorites-grid">
            {favorites.map(brand => (
              <div key={brand.id} className="favorite-card">
                {brand.logo_url && (
                  <img src={brand.logo_url} alt={brand.name} className="brand-logo" />
                )}
                <div className="brand-info">
                  <h3>{brand.name}</h3>
                  <p className="brand-location">{brand.country}</p>
                  <p className="brand-stats">
                    {brand.product_count || 0} products • {brand.branch_count || 0} branches
                  </p>
                </div>
                <div className="brand-actions">
                  <button 
                    className="btn-view"
                    onClick={() => navigate(`/marketplace/brands/${brand.id}`)}
                  >
                    View Store
                  </button>
                  <button 
                    className="btn-remove"
                    onClick={() => handleRemoveFavorite(brand.id)}
                  >
                    ❤️ Unfavorite
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default MyFavorites;